/**
 * 特集商品提案状況確認(CXデザイン部用)画面の特集商品提案状況一覧クラス
 *
 * @export FeatureRequestInfo
 * @class FeatureRequestInfo
 */
export class FeatureRequestInfo {
  public disabled = false;
  public check = false;
  public statusName: string = <string>''; // 表示するステータス名、商品選定済みフラグをもとに設定
  constructor(
	public CatalogId: string,
	public SupplierNameKanji: string,
	public FeatureCode: string,
	public FeatureName: string,
	public SelectionFlag: number,
	public ReplacementStatus: number,
	public OrderCode: string,
	public MediumType: string,
  ) {}
}
  